import { createAuthClient } from 'better-auth/react';

export const authClient = createAuthClient({
  baseURL: import.meta.env.VITE_API_BASE_URL,
  sessionOptions: {
    refetchOnWindowFocus: false
  }
});

export const { useSession, signIn, signUp, signOut, requestPasswordReset, resetPassword } =
  authClient;
